export default __webpack_public_path__ + "static/beach-d98ccaa26af1002c3dcd8e9ad1733a11.jpg";